import { InputTypes } from "../InputTypes";

export const Podcast = Object.freeze({
  name: {
    visibleName: "Título",
    type: InputTypes.TEXT,
  },
  //REMOVE ME : this field is auto setup in the backend
  // timestamp: {
  //   visibleName: "Visible Desde",
  //   type: InputTypes.DATE,
  // },
  visible_timestamp: {
    visibleName: "Visible Desde",
    type: InputTypes.DATE,
  },
  text: {
    visibleName: "Descripción",
    type: InputTypes.RICH_TEXT_AREA,
  },
  media: {
    visibleName: "Media",
    type: InputTypes.PREVIEW,
  },
});
